import { ValidateCurrentToken } from "./validate-token";

export const analyzeConnectionQuality = () => {
  // Si no hay conexión
  if (!navigator.onLine) {
    return {
      quality: "sin-internet" as const,
      canUpload: false,
      message: "Sin conexión a internet",
      description: "Conecta a internet para subir videos",
      speedMbps: 0,
      isWiFi: false,
    };
  }

  return {
    quality: "internet-bueno" as const,
    canUpload: true,
    message: "Internet moderado",
    description: "Se recomienda WiFi para videos",
    speedMbps: 1,
    isWiFi: true,
  };

  // Obtener información de conexión del navegador
  const connection =
    (navigator as any).connection ||
    (navigator as any).mozConnection ||
    (navigator as any).webkitConnection;

  let speedMbps = 1; // Velocidad por defecto
  let effectiveType = "unknown";
  let isWiFi = false;

  if (connection) {
    speedMbps = connection.downlink || 0;
    effectiveType = connection.effectiveType || "unknown";

    // Detectar si es WiFi (no completamente confiable, pero útil)
    isWiFi = connection.type === "wifi" || !connection.type || speedMbps > 10; // Asumimos WiFi si velocidad > 10Mbps
  }

  // Clasificar calidad específicamente para videos
  // if (effectiveType === "slow-2g" || effectiveType === "2g" || speedMbps < 1) {
  //   return {
  //     quality: "internet-lento" as const,
  //     canUpload: false,
  //     message: "Internet muy lento",
  //     description: "Se necesita mejor conexión para videos",
  //     speedMbps,
  //     isWiFi
  //   };
  // }

  // if (effectiveType === "3g" || speedMbps < 2) {
  //   return {
  //     quality: "internet-regular" as const,
  //     canUpload: true,
  //     message: "Internet regular",
  //     description: "Se recomienda WiFi para videos grandes",
  //     speedMbps,
  //     isWiFi
  //   };
  // }

  // if (isWiFi || speedMbps >= 2) {
  //   return {
  //     quality: "internet-bueno" as const,
  //     canUpload: true,
  //     message: isWiFi ? "WiFi conectado" : "Internet rápido",
  //     description: "Conexión excelente para videos",
  //     speedMbps,
  //     isWiFi
  //   };
  // }

  // Caso por defecto - conexión moderada
  return {
    quality: "internet-bueno" as const,
    canUpload: true,
    message: "Internet moderado",
    description: "Se recomienda WiFi para videos",
    speedMbps,
    isWiFi,
  };
};

export const uploadVideoDirectly = async (
  videoFile: File,
  container: string,
  type: "videoContenedorVacio" | "videoCajas" | "videoCierreContenedor",
  containerType: "empty" | "full",
  onProgress?: (progress: number) => void
) => {
  const token = ValidateCurrentToken();
  if (!token) {
    throw new Error("Sesión expirada");
  }

  const formData = new FormData();
  formData.append("video", videoFile);
  formData.append("type", type);
  formData.append("containerType", containerType);
  formData.append("container", container);

  const xhr = new XMLHttpRequest();

  return new Promise((resolve, reject) => {
    // Manejar progreso
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        const progress = Math.round((event.loaded / event.total) * 100);
        onProgress(progress);
      }
    };

    // Manejar respuesta exitosa
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          const response = JSON.parse(xhr.responseText);
          resolve(response);
        } catch (error) {
          resolve({
            id: Date.now(),
            alert: "Video subido correctamente",
            variant: "success",
          });
        }
      } else {
        reject(
          new Error(`Error del servidor: ${xhr.status} ${xhr.statusText}`)
        );
      }
    };

    // Manejar errores de red
    xhr.onerror = () => {
      reject(new Error("Error de conexión - verifica tu internet"));
    };

    // Manejar timeout
    xhr.ontimeout = () => {
      reject(
        new Error(
          "Tiempo de espera agotado - el video es muy grande para tu conexión"
        )
      );
    };

    // Configurar timeout adaptativo basado en tamaño
    const timeoutMinutes = Math.max(
      5,
      Math.ceil(videoFile.size / (1024 * 1024) / 10)
    ); // 1 min por cada 10MB, mín 5min
    xhr.timeout = timeoutMinutes * 60 * 1000;

    // Iniciar upload
    xhr.open(
      "POST",
      `${process.env.REACT_APP_BACKEND}api/workflow-container-videos`
    );
    xhr.setRequestHeader("Authorization", token);
    xhr.send(formData);
  });
};
